import React from 'react';
import { Stack } from '@cp/ds/src/components/stack';
import { ClientPhotoCard } from '@cp/entities/clientPhoto';
import { Typography } from '@cp/ds/src/components/typography';
import { mergeSx } from '@cp/ds/src/utils/sx/merge';
import { AuthorProps } from './model';

export * from './model';

export const Author: React.FC<AuthorProps> = ({ data, sx }) => {
  const name = [data.clientProfile?.name, data.clientProfile?.patronymic].filter(Boolean).join(' ');

  return (
    <Stack direction="row" sx={mergeSx({ alignItems: 'center' }, sx)}>
      <ClientPhotoCard data={data.clientProfile} size={36} />
      <Typography sx={{ color: 'gray', ml: 1.5 }} variant="body">
        Объявление от: {name}
      </Typography>
    </Stack>
  );
};
